export default {
  page: 2,
  assets: [],
  filters: {},
}